import { useMemo } from "react"
import { chain, map, size } from "lodash"
import PropTypes from "prop-types"
import TableRow from "../table-row"
import GroupedTableRow from "../grouped-table-row"
import NoContributionsRow from "../NoContributionsRow"
import PaginationWrapper from "components/pagination-wrapper"

function GroupedTableBody({
  selected,
  openSecurityProfile,
  openFactorProfile,
  openBasket,
  selectedGroup,
  showGroup,
  groupedData,
  noPercent,
  hideSelectedField,
  enableBasketDrillDown,
  page,
  setPage,
  formatter,
}) {
  const groupRows = useMemo(() => {
    const contributors = chain(groupedData)
      .first()
      .get("contributors")
      .value()
    if (size(contributors)) {
      return map(contributors, (contributor, index) =>
        <TableRow
          key={index}
          contributor={contributor}
          selected={selected}
          noPercent={noPercent}
          openSecurityProfile={openSecurityProfile}
          openFactorProfile={openFactorProfile}
          openBasket={openBasket}
          hideSelectedField={hideSelectedField}
          enableBasketDrillDown={enableBasketDrillDown}
          formatter={formatter}
        />,
      )
    }

    return null
  }, [enableBasketDrillDown, groupedData, hideSelectedField, noPercent, openBasket, openFactorProfile, openSecurityProfile, selected, formatter])

  if (selectedGroup) {
    if (!size(groupRows)) {
      return <NoContributionsRow />
    }

    return <PaginationWrapper {...{ rows: groupRows, page, setPage }} />
  }

  if (groupedData.length) {
    return map(groupedData, (group) =>
      <GroupedTableRow
        key={group.name}
        group={group}
        noPercent={noPercent}
        showGroup={showGroup}
        selectedGroup={selectedGroup}
        selected={selected}
        hideSelectedField={hideSelectedField}
        formatter={formatter}
      />,
    )
  }

  return <NoContributionsRow />
}

GroupedTableBody.propTypes = {
  selected: PropTypes.object.isRequired,
  openSecurityProfile: PropTypes.func.isRequired,
  openFactorProfile: PropTypes.func.isRequired,
  openBasket: PropTypes.func,
  selectedGroup: PropTypes.object,
  showGroup: PropTypes.func.isRequired,
  groupedData: PropTypes.array.isRequired,
  hideSelectedField: PropTypes.bool,
  noPercent: PropTypes.bool,
  enableBasketDrillDown: PropTypes.bool,
  page: PropTypes.number,
  setPage: PropTypes.func,
  formatter: PropTypes.func,
}

export default GroupedTableBody
